import React from 'react';
import heroImage from '../../../assets/images/hero_image.png';

const HeroAvatar = () => {
  return (
    <div className="relative w-full h-full flex justify-center items-center">
      {/* Hero Image - centered and scaled larger */}
      <div className="relative w-full transform lg:scale-125 lg:translate-x-10">
        <img
          src={heroImage}
          alt="Anie Joseph Cabahug"
          className="w-full h-auto object-contain"
        />

        {/* Floating Code Elements */}
        <div className="absolute top-10 left-0 bg-blue-500 text-white px-3 py-1.5 rounded text-sm animate-bounce">
          &lt;/&gt;
        </div>
        <div className="absolute top-20 right-0 bg-green-500 text-white px-3 py-1.5 rounded text-sm animate-bounce" style={{ animationDelay: '0.5s' }}>
          { }
        </div>
        <div className="absolute bottom-20 left-0 bg-purple-500 text-white px-3 py-1.5 rounded text-sm animate-bounce" style={{ animationDelay: '1s' }}>
          npm
        </div>
        <div className="absolute bottom-10 right-0 bg-yellow-500 text-black px-3 py-1.5 rounded text-sm animate-bounce" style={{ animationDelay: '1.5s' }}>
          ⚡
        </div>
      </div>
    </div>
  );
};

export default HeroAvatar;
